import { render, staticRenderFns } from "./FormCheckboxes.vue?vue&type=template&id=32a042b2"
import script from "./FormCheckboxes.vue?vue&type=script&lang=js"
export * from "./FormCheckboxes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports